import { useState } from 'react';
import { useLocalization } from '@/hooks/useLocalization';
import { useLead } from '@/hooks/useLead';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import { validateEmail } from '@/utils/validators';
import formStyles from '@/styles/forms.module.scss';

export default function EmailEditScreen() {
  const { t } = useLocalization();
  const { leadData, setEmail } = useLead();
  const { submitEditedEmail } = useChat();
  const [error, setError] = useState(null);

  const handleSubmit = () => {
    const err = validateEmail(leadData.email);
    setError(err);
    if (!err) submitEditedEmail();
  };

  return (
    <BotMessage text={t('emailEdit.message')}>
      <div className={formStyles.emailForm}>
        <label className={formStyles.label} htmlFor="ibc-email-edit">
          {t('contacts.emailLabel')}
        </label>
        <input
          id="ibc-email-edit"
          className={[formStyles.input, error ? formStyles.error : ''].filter(Boolean).join(' ')}
          type="email"
          placeholder={t('contacts.emailPlaceholder')}
          value={leadData.email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (error) setError(null);
          }}
          autoComplete="email"
        />
        {error && <span className={formStyles.errorMsg}>{error}</span>}
        <OptionButton variant="primary" onClick={handleSubmit}>
          {t('emailEdit.continue')}
        </OptionButton>
      </div>
    </BotMessage>
  );
}
